export default "__VITE_ASSET__B$N6DoNa__"